import React from "react"
import { NavLink } from "react-router-dom"
import { cn } from "../../lib/utils"

interface HeaderTabProps {
  to: string
  children: React.ReactNode
  end?: boolean
}

export function HeaderTab({ to, children, end }: HeaderTabProps) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        cn(
          "relative px-4 py-2 text-sm font-medium transition-all duration-200 whitespace-nowrap",
          // Mobile/Tablet: pill style
          "rounded-full",
          isActive
            ? "text-white bg-primary lg:text-foreground lg:bg-transparent"
            : "text-muted-foreground hover:text-foreground"
        )
      }
    >
      {({ isActive }) => (
        <>
          {children}
          {/* Desktop: underline indicator */}
          {isActive && (
            <span
              className={cn(
                "absolute bottom-0 left-2 right-2 h-0.5 rounded-full",
                "bg-gradient-to-r from-primary to-primary-400",
                "animate-tab-underline origin-left",
                "hidden lg:block"
              )}
            />
          )}
        </>
      )}
    </NavLink>
  )
}

interface HeaderTabButtonProps {
  children: React.ReactNode
  isActive?: boolean
  onClick?: () => void
}

export function HeaderTabButton({
  children,
  isActive = false,
  onClick,
}: HeaderTabButtonProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "relative px-4 py-2 text-sm font-medium transition-all duration-200",
        isActive ? "text-gray-900" : "text-muted-foreground hover:text-foreground"
      )}
    >
      {children}
      {isActive && (
        <span
          className={cn(
            "absolute bottom-0 left-2 right-2 h-0.5 rounded-full",
            "bg-gradient-to-r from-primary to-primary-400",
            "animate-tab-underline origin-left"
          )}
        />
      )}
    </button>
  )
}
